'use strict';
import { AppConfigurations } from '../config/app.config';
const apiConfig = new AppConfigurations();
export const APP_TITLE: string = apiConfig.config.title;
export const APP_ENVIRONMENT: string = apiConfig.config.environment;
export const SERVER_URL: string = apiConfig.config.apiUrl.backendUrl;
export const FE_URL: string = apiConfig.config.apiUrl.frontendUrl;
export const CMS_URL: string = apiConfig.config.apiUrl.cmsUrl;
export const ADMIN_BASE_URL: string = `${SERVER_URL}/admin`;

export const USER_AUTH_BASE_URL: string = `${SERVER_URL}/auth`;

// export const LOGIN: string = `${USER_AUTH_BASE_URL}/login`;
export const LOGIN: string = `${SERVER_URL}/user/authenticate`;
export const SIGN_UP: string = `${SERVER_URL}/member/signup`;
export const RESET_PASSWORD: string = `${USER_AUTH_BASE_URL}/reset-password`;
export const RESET_PASSWORD_CONFIRMATION: string = `${USER_AUTH_BASE_URL}/reset-password/confirmation`;
export const VERIFY_OTP: string = `${USER_AUTH_BASE_URL}/otp/verify`;
export const RESEND_OTP: string = `${USER_AUTH_BASE_URL}/otp/resend`;
export const GET_USER_DETAILS: string = `${USER_AUTH_BASE_URL}/me`;
export const LOGOUT: string = `${USER_AUTH_BASE_URL}/me/logout`;

// User-management

export const USER_MANAGEMENT_BASE_URL: string = `${SERVER_URL}users`;
export const CHANGE_PASSWORD: string = `${SERVER_URL}/user/change-password`;


// Contact US
export const CONTACT_US_URL: string = `${SERVER_URL}/common/contact-us`;

//Tenant
export const TENANT_INFO: string = `${SERVER_URL}/common/tenant-info`;

//Membership
export const MEMBERSHIP_URL: string = `${SERVER_URL}/membership/subscription`;
export const TIMEZONE: string = `${SERVER_URL}/common/time-zone`;

//Member
export const MEMBER_FAMILY: string = `${SERVER_URL}/member/family`;
export const MEMBER_PROFILE: string = `${SERVER_URL}/member/profile`;
//American states
export const STATES: string = `${SERVER_URL}/common/us-state`;
export const COMPARE_MEDS_SEARCH = SERVER_URL + `/compare-meds-rx/search-drug?drugName=`
export const COMPARE_MEDS_FILTER = SERVER_URL + `/compare-meds-rx/filter-drug?drugName=`
export const PHARMACIES_PROVIDERS = SERVER_URL + `/compare-meds-rx/fetch-providers-pharmacies?zipCode=`
export const REVIVE_HEALTH_TRANSFER_DRUG = SERVER_URL + `/revive-health/transfer-drug`
export const DRUG_PRICE = SERVER_URL + `/compare-meds-rx/fetch-drug-price`
export const GENERATE_PROVIDER_CARD = SERVER_URL + `/compare-meds-rx/generate-provider-card`
export const USE_PROVIDER_CARD = SERVER_URL + `/compare-meds-rx/use-provider-card`
//Appointments
export const MEMBER_APPOINTMENTS = SERVER_URL + `/member/appointments`
export const APPOINTMENT = SERVER_URL + `/appointment`

export const REVIVEHEALTH_MEDICATION = SERVER_URL + `/revive-health/search-formulary-acute-drug?query=`
